<template>
  <div>
    <v-overlay :value="overlay"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>
    <v-card>
      <v-card-title class="dialog-header">
        <span class="headline">{{ $t("addImage") }}</span>
        <v-spacer></v-spacer>
        <v-btn
          fab
          text
          icon
          @click="handleClose()"
          valid="false"
          v-shortkey="['esc']"
          @shortkey.native="handleClose()"
        >
        <span class="white--text">
          <v-icon dark>
            mdi-close
          </v-icon>
        </span>
        </v-btn>
      
        </v-card-title>
          <v-card-text>

            <v-form v-model="valid">
              <v-container>
                <fieldset class="multiple-upload">
                  <!-- <legend>Multiple upload:</legend> -->
                  <span style="float:left" class="avatar-container" v-for="(pre, index) in previewImage" :key="index">
                    <img
                      :ref="'image'"
                      aspect-ratio="1"
                      class="grey lighten-2 multiple-preview"
                    >
                    <button type="button" class="remove-avatar" style="top: 2px; right: 8px" @click="removeFileUpload(index)">x</button>
                  </span>
                  <div style="clear:both"></div>
                </fieldset>

                <label id="avatar" style="width: 130px">{{ $t("browImage") }}
                  <input type="file" size="60"
                    multiple
                    accept=".gif, .jpg,.jpeg,.png"
                    @change="upload"
                    >     
                </label>

                <v-divider style="margin-top: 10px;"></v-divider>

                <div style="text-align:right">
                  <v-btn color="default" outlined text @click="handleClose()">
                    {{ $t('close') }}
                  </v-btn>

                  <v-btn class="ma-2 v-btn v-btn--contained theme--light v-size--default success white--text" text @click="submit($event)">
                    <font-awesome-icon icon="check-circle" class="mr-1"/>
                    {{ $t('save') }}
                  </v-btn>
                </div>

              </v-container>
            </v-form>

          </v-card-text>
    </v-card>
  </div>
</template>

<script>
import validatorMixin from "@/mixins/validatorMixin";
import mainMixin from "@/mixins/mainMixin";
import optionDataMixin from "@/mixins/optionDataMixin";
import axios from "axios";
import { provider } from "../../../service/provider";

export default {
  name: "image-upload",
  mixins: [validatorMixin, mainMixin, optionDataMixin],
  data() {
    return {
      previewImage  : [],
    };
  },

  methods: {
      upload(event) {    
        /** * splite extension to check validation */
        let selectedFiles  = event.target.files;
        for (let i = 0; i < selectedFiles.length; i++) {
          this.previewImage.push(selectedFiles[i]);
        }
        this.renderImage();
        event.target.value = '';
      },

      removeFileUpload(index){
        this.previewImage.splice(index, 1);
        this.renderImage();
      },

      renderImage() {
        let vm = this;
        for (let i = 0; i < vm.previewImage.length; i++) {
          let reader = new FileReader();
          reader.onload = () => {
            vm.$refs.image[i].src = reader.result;
          };
          reader.readAsDataURL(vm.previewImage[i]);
        }
      },

    async handleClose(){
        await this.$store.dispatch('updateOutsideBusinessDialog', {dialog: false, dialog_type: ''})
    },

    async submit(e) {
      e.preventDefault();
      let vm = this;
      if (vm.previewImage.length) {

        vm.overlay  = true;
        let url     = provider.baseURL + provider.uploadMultiple;
        let formData= new FormData();

        formData.append("product_id", this.$store.state.outsideBusiness.product_id);
        for( var i = 0; i < this.previewImage.length; i++ ){
            let file = this.previewImage[i];
            formData.append('image[' + i + ']', file);
        }

        return new Promise((resolve, reject) => {

          axios.post(url, formData, {headers: {
            Authorization: localStorage.token,
            "Content-Type": "multipart/form-data"
            }}).then(
              res => {
                if (res.data.response && res.data.response.code === 200) {
                  url = provider.baseURL + provider.storeImageProductRegistration;
                  let params  = {
                        product_id: this.$store.state.outsideBusiness.product_id,
                        image: res.data.data.document_name
                      } 
                  axios.post(url, params, {headers: { Authorization: localStorage.token
                  }}).then(
                    res => {
                      if (res.data.response && res.data.response.code === 200) {
                        vm.overlay  = false;
                         vm.$notify({
                          title: "Success",
                          message: vm.$t("success"),
                          type: "success",
                          duration: 700
                        });

                        vm.$store.dispatch('updateOutsideBusinessDialog', {dialog: false, dialog_type: ''});
                        vm.$store.dispatch('updateOutsideBusinessProductId', '');
                      }
                    },
                    error => {
                        reject(error);
                    }
                  );
                }
              },
              error => {
                  reject(error);
              }
          );

        });
      }

      else{
        vm.$notify({
          title: "Error",
          message: vm.$t("pleaseBroweImage"),
          type: "error",
          duration: 1200
        });
      }
    }
  }
  
};
</script>

<style scoped>
 #avatar{
      text-align: center;
      width: 100%;
      padding: 10px;
      background: gray; 
      display: table;
      color: #fff;
      cursor: pointer;
      margin:0;
      margin-top:10px;
  }
  input[type="file"] {
      display: none;
  }

  .avatar-container {
      position: relative;
  }

  .avatar-container .remove-avatar {
      position: absolute;
      top: 5px;
      right: 5px;
      color: #ffffff;
      background-color: #b3b3b3;
      border-radius: 50%;
      width: 24px;
      height: 25px;
      line-height: 1.5;
  }

  .v-btn--floating .v-btn__content {
      height: auto !important;
  }

  .dimention {
      justify-content: center; 
      display: flex;
  }

  .multiple-upload {
      min-height: 115px;
      border: 1.5px solid gray;
      border-style: dotted;
      padding-left: 5px;
      font-size: 16px;
  }

  .multiple-preview {
      width: 100px; 
      height: 80px;
      margin-right: 5px; 
      margin-bottom: 5px;
  }
</style>